import { ConditionalLink } from "components/conditionalLink";
import { VerifyCardWrapper } from "./VerifyCardWrapper";
import { Button } from "components/DesignSystem/Button/Button";
import { SALES_EMAIL } from "constants/base";

const NEXT_STEPS = [
  "Our team will review a few details to complete your setup.",
  "It usually takes 24 hours.",
  "We will email you once your account is setup.",
];

export const VerifyFailedScreen = () => (
  <VerifyCardWrapper>
    <div className="t-space-y-2">
      <div className="t-text-subtitle-lg t-text-text-100">
        Additional review needed
      </div>
      <div className="t-text-body-sm t-text-text-30">
        We need a bit more time to set up your account
      </div>
    </div>

    <div className="t-space-y-2">
      <div className="t-text-subtext-sm t-text-text-30">What happens next:</div>
      <div className="t-bg-yellow-0 t-border t-border-solid t-border-yellow-20 t-rounded t-py-4 t-px-3 t-flex t-flex-col t-gap-3">
        {NEXT_STEPS.map((step) => (
          <div key={step} className="t-flex t-items-center t-gap-2">
            <span className="t-w-1.5 t-h-1.5 t-rounded-full t-bg-yellow t-shrink-0" />
            <span className="t-text-body-sm t-text-text-30">{step}</span>
          </div>
        ))}
      </div>
    </div>
    <div>
      <ConditionalLink to={`mailto:${SALES_EMAIL}`}>
        <Button customType="link" size="small">
          Need help? Contact support
        </Button>
      </ConditionalLink>
    </div>
  </VerifyCardWrapper>
);
